import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-m', 'age-walking-m'],
		route: {
			path: '/walking-m',
			name: 'male-walking-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'male_funnel', // /walking-m?safe&lptype=male_funnel&lpid=
				},
				ids: ['dynamic-loader-male-light', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-male-activity-walking',
		route: {
			path: '/walking-m/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'male-activity-walking',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'male-activity-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-m',
		overrides: [
			{
				matcher: { country: 'us' },
				routeName: 'plan-walking-m-us',
			},
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-walking-m-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-walking-m'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
